// extracted by mini-css-extract-plugin
module.exports = {"inlineItem":"KeyValue__inlineItem--3B6S8","valueHighlighted":"KeyValue__valueHighlighted--1-y53","valueWithError":"KeyValue__valueWithError--2oLln"};